import ServiceHealthContainer from '../../Components/Workspace/Service Health/ServiceHealthContainer';

export const ServiceHealthUnauthWrapper = () => {
  return (
    <div
      id="pageMainContent"
      role="main"
      style={{
        margin: 'auto',
        maxWidth: '1420px',
        paddingRight: '40px',
        paddingLeft: '40px',
        paddingBottom: '40px',
        paddingTop: '40px',
      }}
    >
      <ServiceHealthContainer isPublic={true}></ServiceHealthContainer>
    </div>
  );
};
